import { useLocation } from "react-router-dom";
import tokens from "@/theme/harvest.json";

export function usePageContext() {
  const { pathname } = useLocation();
  const brand = pathname.startsWith("/high-income-shares") ? "hhis" : "etf";
  const m = pathname.match(/^\/(?:etf|high-income-shares)\/([a-z0-9-]+)\/?$/i);
  const ticker = m && m[1] !== "products" ? m[1].toUpperCase().replace("-", ".") : null;
  return { brand, ticker, path: pathname, theme: tokens.themes[brand] };
}
